import API from "../../../../services/api-request";
import state from "../../../../config/valtio/store";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import FilterMenu from "./filter-menu";
import AddSubscription from "./modal-add-subscription";
import EditSubscription from "./modal-edit-subscription";
import "../../../../assets/css/style-table.css";

const { confirm } = Modal;

const Subscription = () => {
  const [dataSubscription, setDataSubscription] = useState([]);
  const [dataCompany, setDataCompany] = useState([]);
  const [dataSubscriptionFilter, setDataSubscriptionFilter] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const getCompanies = async () => {
    await API.Get("company")
      .then((result) => {
        setDataCompany(result?.data);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Company Data!");
      });
  };

  const getSubscription = async () => {
    state.LOADING = true;

    await API.Get("subscription")
      .then((result) => {
        console.log(result.data);

        const transformedData = result?.data.map((item) => ({
          ...item,
          company_name: dataCompany.find(
            (company) => company.id === item.company_id,
          )?.name,
        }));

        setDataSubscription(transformedData);
        setDataSubscriptionFilter(transformedData);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Subscription Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    if (dataCompany) {
      getSubscription();
    }
  }, [dataCompany]);

  useEffect(() => {
    getCompanies();
  }, []);

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.company_name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.company_name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`subscription/${data.id}`)
          .then(() => {
            message.success("Subscription has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete Subscription");
            console.error(err);
          })
          .finally(() => {
            getSubscription();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Company",
      key: "company_name",
      sorter: (a, b) => a.company_name - b.company_name,
      render: (data) => (data?.company_name ? data?.company_name : "-"),
    },
    {
      title: "Package",
      key: "data",
      sorter: (a, b) => a.data?.package - b.data?.package,
      render: (data) => (data?.package ? data?.package : "-"),
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      sorter: (a, b) => a.start_date - b.start_date,
      render: (start_date) =>
        start_date ? dayjs(start_date).format("YYYY-MM-DD") : "-",
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      sorter: (a, b) => a.end_date - b.end_date,
      render: (end_date) =>
        end_date ? dayjs(end_date).format("YYYY-MM-DD") : "-",
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSearch = async (val) => {
    let data = dataSubscription.filter((subscription) =>
      subscription.package.toLowerCase().includes(val.toLowerCase()),
    );

    setDataSubscriptionFilter(data);
  };

  const onClear = async (val) => {
    getSubscription();
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <FilterMenu onShowAdd={onShowAdd} onSearch={onSearch} onClear={onClear} />

      {/* Subscription Table */}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataSubscriptionFilter}
        rowClassName={rowClassName}
        scroll={{
          x: 1000,
        }}
        size="large"
      />

      {/* Modal Add Subscription */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddSubscription
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetSubscription={getSubscription}
        />
      </div>

      {/* Modal Edit Subscription */}
      <EditSubscription
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetSubscription={getSubscription}
        selectedData={selectedData}
      />
    </>
  );
};

export default Subscription;
